
/* ===== VELANTIS_CAB_CAROUSEL — carrusel por categoría (crossfade, auto-detecta <cat>-N) ===== */
(function(){
  var car=document.getElementById('catCarousel'); if(!car) return;
  var track=document.getElementById('ccTrack'), vp=document.getElementById('ccViewport'),
      prev=document.getElementById('ccPrev'), next=document.getElementById('ccNext'),
      dots=document.getElementById('ccDots');
  var slides=[], idx=0, timer=null, curKey=null;
  var reduce=matchMedia('(prefers-reduced-motion:reduce)').matches;
  var EXTS=['.jpg','.jpeg','.png','.webp','.svg'], MAX=20;
  var VIDEO='//velantis.mx/cdn/shop/t/25/assets/video-hero-nuevo-.mp4?v=174742080298282338581788483761'; // 1er slide del carrusel en TODAS las categorías
  var ROUTES={ 'caballero':'caballero','dama':'dama','unisex':'unisex',
               'ambientales':'ambientales','best-sellers':'best-sellers','novedades':'novedades' };
  var LABEL={ 'caballero':'Caballero','dama':'Dama','unisex':'Unisex',
              'ambientales':'Ambientales','best-sellers':'Best Sellers','novedades':'Novedades' };
  var cache={};
  // Mapa ESTÁTICO de imágenes por categoría -> carga instantánea, sin probar extensiones (era lo lento)
  var IMGMAP={
    caballero:['//velantis.mx/cdn/shop/t/25/assets/caballero-1.jpg?v=37410402525764510111788483485','//velantis.mx/cdn/shop/t/25/assets/caballero-2.jpg?v=156852330270990275711788483486','//velantis.mx/cdn/shop/t/25/assets/caballero-3.jpg?v=140062530944790590461788483486'],
    dama:['//velantis.mx/cdn/shop/t/25/assets/dama-1.jpg?v=992089712460400711788483487','//velantis.mx/cdn/shop/t/25/assets/dama-2.jpg?v=175615831336950253961788483487'] /* 3-sep: 2a foto nueva (la casa) */,
    unisex:['//velantis.mx/cdn/shop/t/25/assets/unisex-1.jpg?v=77867729807828263471788483572','//velantis.mx/cdn/shop/t/25/assets/unisex-2.jpg?v=15122499421086861081788483573','//velantis.mx/cdn/shop/t/25/assets/unisex-3.jpg?v=140062530944790590461788483573'],
    ambientales:['//velantis.mx/cdn/shop/t/25/assets/ambientales-1.jpg?v=101517072917146743231788483478','//velantis.mx/cdn/shop/t/25/assets/ambientales-2.jpg?v=130397862570095694241788483479','//velantis.mx/cdn/shop/t/25/assets/ambientales-3.jpg?v=70713815982556315961788483479'],
    'best-sellers':['//velantis.mx/cdn/shop/t/25/assets/best-sellers-1.jpg?v=992089712460400711788483480','//velantis.mx/cdn/shop/t/25/assets/best-sellers-2.jpg?v=992089712460400711788483480'],
    novedades:['//velantis.mx/cdn/shop/t/25/assets/novedades-1.jpg?v=992089712460400711788483565','//velantis.mx/cdn/shop/t/25/assets/novedades-2.jpg?v=992089712460400711788483565']
  };

  function routeKey(){ var m=/^#\/([a-z-]+)/.exec(location.hash||''); return (m && ROUTES[m[1]])? m[1] : null; }

  function probe(base,n){return new Promise(function(res){
    var i=0;(function t(){ if(i>=EXTS.length){res(null);return;}
      var im=new Image(); im.onload=function(){res(base+'-'+n+EXTS[i]);}; im.onerror=function(){i++;t();};
      im.src=base+'-'+n+EXTS[i];
    })();});}
  function discover(base){return (function loop(n,found){
    if(n>MAX) return Promise.resolve(found);
    return probe(base,n).then(function(p){ if(!p) return found; found.push(p); return loop(n+1,found); });
  })(1,[]);}

  function build(imgs,key){
    var name=LABEL[key]||'Velantis';
    var NOVIDEO={caballero:1,dama:1,unisex:1}; // sin video hero en estas categorías
    if(car) car.classList.toggle('cc-clean', !!NOVIDEO[key]); // sin flechas + dots blancos (estilo ambiental)
    var vslide=NOVIDEO[key]?'':'<div class="cc-slide on"><video class="cc-vid" src="'+VIDEO+'" muted loop playsinline autoplay preload="metadata"></video></div>';
    var islides=imgs.map(function(src,i){
      var on=(!vslide && i===0);
      return '<div class="cc-slide'+(on?' on':'')+'"><img src="'+src+'" alt="Velantis '+name+' '+(i+1)+'" draggable="false"></div>';
    }).join('');
    track.innerHTML=vslide+islides;
    slides=[].slice.call(track.children);
    dots.innerHTML=slides.map(function(_,i){
      return '<button class="cc-dot'+(i===0?' on':'')+'" type="button" data-i="'+i+'" aria-label="Ir a la diapositiva '+(i+1)+'"></button>';
    }).join('');
    var multi=slides.length>1;
    prev.hidden=next.hidden=!multi; dots.hidden=!multi;
    idx=0; place();
  }
  function place(){
    slides.forEach(function(s,i){ var on=i===idx; s.classList.toggle('on',on);
      var v=s.querySelector('video'); if(v){ if(on){ var pr=v.play&&v.play(); if(pr&&pr.catch)pr.catch(function(){}); } else { v.pause&&v.pause(); } } });
    [].forEach.call(dots.children,function(d,i){ d.classList.toggle('on',i===idx); });
  }
  function go(i){ if(!slides.length)return; idx=(i%slides.length+slides.length)%slides.length; place(); }
  function nextS(){ go(idx+1); } function prevS(){ go(idx-1); }

  prev.addEventListener('click',function(e){ e.preventDefault(); e.stopPropagation(); prevS(); restartAuto(); });
  next.addEventListener('click',function(e){ e.preventDefault(); e.stopPropagation(); nextS(); restartAuto(); });
  dots.addEventListener('click',function(e){ var b=e.target.closest('.cc-dot'); if(b){ go(+b.dataset.i); restartAuto(); } });

  function startAuto(){ if(reduce||slides.length<2||car.hidden)return; stopAuto(); timer=setInterval(function(){go(idx+1);},5000); }
  function stopAuto(){ if(timer){clearInterval(timer);timer=null;} }
  function restartAuto(){ stopAuto(); startAuto(); }
  car.addEventListener('mouseenter',stopAuto);
  car.addEventListener('mouseleave',startAuto);

  // swipe simple (sin captura de puntero, para no romper el click de las flechas)
  var startX=0,down=false;
  vp.addEventListener('pointerdown',function(e){
    if(slides.length<2)return; if(e.target.closest('.cc-arrow'))return;
    down=true; startX=e.clientX; stopAuto();
  });
  vp.addEventListener('pointerup',function(e){
    if(!down)return; down=false; var dx=e.clientX-startX;
    if(Math.abs(dx)>40){ dx<0?nextS():prevS(); } startAuto();
  });
  vp.addEventListener('pointercancel',function(){ down=false; startAuto(); });

  document.addEventListener('keydown',function(e){
    if(car.hidden)return;
    if(e.key==='ArrowRight'){ nextS(); restartAuto(); }
    else if(e.key==='ArrowLeft'){ prevS(); restartAuto(); }
  });

  function show(key){
    var imgs=cache[key]||[];
    build(imgs,key); car.hidden=false; startAuto();  // el video siempre está presente
  }
  function onRoute(){
    var key=routeKey();
    if(!key){ car.hidden=true; stopAuto(); curKey=null; return; }
    if(key===curKey){ if(!car.hidden) startAuto(); return; }
    curKey=key; stopAuto(); car.hidden=true;
    if(cache[key]){ show(key); return; }
    if(IMGMAP[key]){ cache[key]=IMGMAP[key].slice(); show(key); return; } // instantáneo
    discover(ROUTES[key]).then(function(imgs){ cache[key]=imgs; if(routeKey()===key) show(key); });
  }
  window.addEventListener('hashchange',onRoute);
  onRoute();
})();
